import classNames from "classnames";
import classes from "./ModalDelete.module.scss";
import React, { FC } from "react";
import { Button } from "../../Button/Button";
import modalBase from "../../../ModalBase/ModalBase.module.scss";

type ModalUserDeleteProps = {
  isActive: boolean;
  setActive: (value: boolean) => void;
  deleteUser: (userId: number) => void;
  userId: number;
  isDeleteUserLoading: boolean;
};

export const ModalUserDelete: FC<ModalUserDeleteProps> = ({
  isActive,
  setActive,
  userId,
  deleteUser,
  isDeleteUserLoading,
}) => {
  return (
    <div
      className={classNames(modalBase.modal, { [modalBase.active]: isActive })}
      onClick={() => setActive(false)}
    >
      <div
        className={classNames(modalBase.container, classes.modalDelete)}
        onClick={(e: React.MouseEvent<HTMLDivElement>) => e.stopPropagation()}
      >
        {isDeleteUserLoading && (
          <div className={classes.load}>
            <div className={classes.loadContent}>
              <p>Удаление...</p>
            </div>
          </div>
        )}
        <h2 className={modalBase.title}>Удалить?</h2>
        <div className={classes.buttonsContainer}>
          <button
            className={classNames(classes.normal, classes.whiteBtnNo)}
            onClick={() => setActive(false)}
          >
            {"НЕТ"}
          </button>

          <Button
            content={"ДА"}
            btnStyle={"blue"}
            isDeleteBtn={true}
            onClick={() => deleteUser(userId)}
            isLoading={isDeleteUserLoading}
          />
        </div>
      </div>
    </div>
  );
};
